export var IntelligentPhotoCaptureSignalRConnectionEventType;
(function (IntelligentPhotoCaptureSignalRConnectionEventType) {
    IntelligentPhotoCaptureSignalRConnectionEventType["RECONNECTED"] = "RECONNECTED";
    IntelligentPhotoCaptureSignalRConnectionEventType["DISCONNECTED"] = "DISCONNECTED";
    IntelligentPhotoCaptureSignalRConnectionEventType["ERROR"] = "ERROR";
    IntelligentPhotoCaptureSignalRConnectionEventType["RECEIVE_NOTIFICATION"] = "RECEIVE_NOTIFICATION";
})(IntelligentPhotoCaptureSignalRConnectionEventType || (IntelligentPhotoCaptureSignalRConnectionEventType = {}));
//# sourceMappingURL=IntelligentPhotoCaptureSignalRConnectionEventType.js.map